module.exports = __webpack_public_path__ + "static/17-073b9b63ebdac7c8a24e71ed3dcd11ed.jpg";